
// export const logout = ( state ) => {
// }

export const setVehicles = (state, vehicles) => {
    state.vehicles = vehicles
}

export const setVehiclesSelectable = (state, vehicles) => {
    state.vehiclesSelectable = vehicles
}

export const setVehiclesPaginated = (state, vehiclesPaginatedData) => {
    state.vehiclesPaginatedData = vehiclesPaginatedData
}

export const setVehicleDetail = (state, vehicle) => {
    state.vehicle = vehicle
}

export const saveNewVehicles = (state, vehicle) => {
    state.vehicles.unshift(vehicle)
    state.createdData = vehicle;
}

export const saveUpdatedVehicle = (state, vehicle) => {
    state.vehicles.unshift(vehicle)
    state.updatedData = vehicle;
}

export const setDeleteVehicle = (state, vehicle) => {
    
    state.vehiclesPaginatedData.data.filter(x => x.id !== vehicle.id);
    state.deletedData = vehicle
}

export const setVehicleIsLoading = (state, isLoading) => {
    state.isLoading = isLoading
}

export const setVehicleIsCreating = (state, isCreating) => {
    state.isCreating = isCreating
}

export const setVehicleIsUpdating = (state, isUpdating) => {
    state.isUpdating = isUpdating
}

export const setVehicleIsDeleting = (state, isDeleting) => {
    state.isDeleting = isDeleting
}
